import { GET_OVERRIDABLE_ERRORS } from '../../constants/actions/policy';

export function getOverridableErrors() {
    return {
        type: GET_OVERRIDABLE_ERRORS,
    };
}
